
import { useLocation, useNavigate } from 'react-router-dom';

export default function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    {
      icon: 'ri-home-line',
      activeIcon: 'ri-home-fill',
      label: 'الرئيسية',
      path: '/dashboard'
    },
    {
      icon: 'ri-briefcase-line',
      activeIcon: 'ri-briefcase-fill',
      label: 'الوظائف',
      path: '/jobs'
    },
    {
      icon: 'ri-folder-line',
      activeIcon: 'ri-folder-fill',
      label: 'مشاريعي',
      path: '/projects'
    },
    {
      icon: 'ri-user-line',
      activeIcon: 'ri-user-fill',
      label: 'الملف الشخصي',
      path: '/profile'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-0">
      <div className="grid grid-cols-4 h-16">
        {navItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={index}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center h-full transition-colors ${
                isActive ? 'text-[#1565C0]' : 'text-[#757575]'
              }`}
            >
              <i className={`${isActive ? item.activeIcon : item.icon} text-lg mb-1`}></i>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
